export const incorrectLabelFeedbackIcon = {
  svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.41L3.58 5.99C3.22 6.34 3 6.84 3 7.38V17.38C3 18.48 3.9 19.37 5 19.37L16 19.38C16.28 19.38 16.55 19.31 16.79 19.2L18.97 21.38L20.38 19.97L3.41 3L2 4.41ZM16 7.38L19.55 12.38L17.92 14.67L19.35 16.1L22 12.38L17.63 6.22C17.27 5.71 16.67 5.38 16 5.38L8.63 5.39L10.63 7.38H16ZM5 17.38H14.97L5 7.41V17.38Z" fill="#6145CE" fill-opacity="0.87"/>
    </svg>
    `,
  name: 'incorrectLabelFeedback',
};
